<template>
  <v-container fluid class="account-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-list-box</v-icon>
            Account
          </v-tab>
          <v-tab
            :href="`#tab-options`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-cog-box</v-icon>
            Options
          </v-tab>
          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Account</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'accountnum')"
                        v-bind:value="initvalue.accountnum"
                        placeholder="Account Num"
                        persistent-hint
                        single-line hint="Enter the account num">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'accountcode')"
                        v-bind:value="initvalue.accountcode"
                        placeholder="Account Code"
                        persistent-hint
                        single-line hint="Enter the account code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'accountname')"
                        v-bind:value="initvalue.accountname"
                        placeholder="Account Name"
                        persistent-hint
                        single-line hint="Enter the account name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="[
                          {text: 'None', value: null},
                          ...data_accounts.filter(x=>x.accountclass==initvalue.accountclass)
                          .map(x => {
                          return {text: `${x.accountnum}: ${x.accountname}`, value: x._id};
                          })
                        ]"
                        v-bind:value="initvalue.parent_accountid"
                        v-on:change="updateChangedValue($event, 'parent_accountid')"
                        outlined
                        dense
                        placeholder="Sum Account"
                        persistent-hint
                        single-line hint="Please choose the sum account">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'accountstatus')"
                          v-bind:label="initvalue.accountstatus"
                          v-model="initvalue.accountstatus"
                          value="Active"
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items=Object.keys(classes)
                        :value="initvalue.accountclass"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'accountclass')"
                        placeholder="Class"
                        persistent-hint
                        single-line hint="Please choose the account class">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items=classes[accountclass]
                        :value="initvalue.accountsubclass"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'accountsubclass')"
                        placeholder="Subclass"
                        persistent-hint
                        single-line hint="Please choose the account subclass">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items=accounttype
                        :value="initvalue.accounttype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'accounttype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the account type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items=accountsubtype
                        :value="initvalue.accountsubtype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'accountsubtype')"
                        placeholder="Subtype"
                        persistent-hint
                        single-line hint="Please choose the subtype">
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/account/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editAccount()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            :value="'tab-options'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-form>
                      <p class="text-h5">Edit Options</p>
                      <v-select
                        class="mb-2"
                        :items="['Straight Line', 'Declining Balance']"
                        outlined
                        dense
                        v-on:change="onChangeOptions($event, 'depreciationmethod')"
                        v-bind:value="initvalue.options!=null ? initvalue.options.depreciationmethod: ''"
                        placeholder="Method"
                        persistent-hint
                        single-line hint="Please choose the depreciation method">
                      </v-select>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            type="number"
                            class="mb-2"
                            outlined
                            dense
                            v-on:change="onChangeOptions($event, 'depreciationrate')"
                            v-bind:value="initvalue.options!=null ? initvalue.options.depreciationrate: ''"
                            placeholder="Rate"
                            persistent-hint
                            single-line hint="Enter depreciation rate">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            type="number"
                            class="mb-2"
                            outlined
                            dense
                            v-on:change="onChangeOptions($event, 'depreciationyear')"
                            v-bind:value="initvalue.options!=null ? initvalue.options.depreciationyear: ''"
                            placeholder="Years"
                            persistent-hint
                            single-line hint="Enter depreciation years">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-select
                        class="mb-2"
                        :items="[
                          {text: 'None', value: null},
                          ...data_accounts.filter(x=>x.accountsubclass=='Cost of Sales' || x.accountclass=='Expense' || x.accountclass=='Other')
                          .map(x => {
                          return {text: `${x.accountnum}: ${x.accountname}`, value: x._id};
                          })
                        ]"
                        v-bind:value="initvalue.options!=null ? initvalue.options.debit_accountid: null"
                        v-on:change="onChangeOptions($event, 'debit_accountid')"
                        outlined
                        dense
                        placeholder="Debit Account"
                        persistent-hint
                        single-line hint="Debit Account">
                      </v-select>
                      <v-select
                        class="mb-2"
                        :items="[
                          {text: 'None', value: null},
                          ...data_accounts.filter(x=>x.accountsubclass=='Current Asset' || x.accountsubclass=='Other Asset')
                          .map(x => {
                          return {text: `${x.accountnum}: ${x.accountname}`, value: x._id};
                          })
                        ]"
                        v-bind:value="initvalue.options!=null ? initvalue.options.credit_accountid: null"
                        v-on:change="onChangeOptions($event, 'credit_accountid')"
                        outlined
                        dense
                        placeholder="Credit Account"
                        persistent-hint
                        single-line hint="Credit Account">
                      </v-select>
                      <v-row no-gutters>
                        <v-col col="12" md="6">
                          <v-switch
                            color="primary"
                            v-model="edit_options.isFixedAsset"
                            v-on:change="onChangeOptions($event, 'isFixedAsset')"
                            v-bind:value="edit_options.options ? edit_options.options.isFixedAsset : false"
                            hint="Fixed Asset Account"
                            :false-value="false"
                            persistent-hint
                        ></v-switch>
                        </v-col>
                        <v-col col="12" md="6">
                          <v-switch
                            color="primary"
                            v-model="edit_options.isVehicleExpense"
                            v-on:change="onChangeOptions($event, 'isVehicleExpense')"
                            v-bind:value="edit_options.options ? edit_options.options.isVehicleExpense : false"
                            hint="Vehicle Expense Account"
                            :false-value="false"
                            persistent-hint
                        ></v-switch>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/account/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="editOptionsRequest()">
                          Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';
import { sortDataAsc } from '@/util/tools';

export default {
  data () {
    return {
      edit_options: {},
      change_account: {},
      change_options: {},
      initvalue: {},
      accountclass: null,
      classes: {
        'Asset': ['Cash', 'Bank', 'Current Asset', 'Other Asset'],
        'Liability': ['Current Liability', 'Other Liability', 'Loan Payable'],
        'Equity': ['Equity', 'Retained Earnings', 'Other Equity'],
        'Revenue': ['Sales Income', 'Sales Discount', 'Service Income', 'Cost of Sales', ],
        'Cost': ['Cost of Goods Sold', 'Other Cost of Goods Sold'],
        'Expense': ['Cost of Good Sold', 'Administrative Expense', 'Operating Expense', 'Marketing Expense', 'Tax & Financing Expense', 'Factory & Production Expense', 'Debt & Loan', 'Overhead'],
        'Payroll': ['Salary', 'Salary Items', 'Employee Benefit', 'Flexible Savings', 'Flexible Work', 'Claims'],
        'Other': ['Other Income', 'Other Expense'],
      },
      accounttype: ['Credit', 'Debit'],
      accountsubtype: ['Account', 'Addition', 'Deduction', 'Contribution', 'Benefit', 'Saving', 'Flexible Work', 'Expense Claim', 'Medical Claim', 'Other'],
    }
  },
  methods: {
    ...mapActions('Account', ['updateAccountRequest','updateAccountOptionsRequest', 'getAccountsRequest']),
    editAccount() {
      this.change_account._id = this.initvalue._id;
      this.updateAccountRequest(this.change_account);
      this.getAccountsRequest();
      router.push('/account/list');
    },
    async editOptionsRequest() {
      this.change_options._id = this.initvalue._id;
      console.log(this.change_options)
      await this.updateAccountOptionsRequest(this.change_options);
      router.push('/account/list');
    },
    updateChangedValue(value, field){
      if(field=='accountclass') this.accountclass = value;
      this.change_account[field] = value;
    },
    onChangeOptions(value, field){
      this.change_options[field] = value;
    },
  },
  computed: {
    ...mapState('Account', ['accounts', 'isReceiving']),
    data_accounts(){
      let results = Object.assign([], this.accounts);
      sortDataAsc(results, 'accountnum');
      return results;
    }
  },
  async created () {
    this.initvalue = this.$route.params;
    this.accountclass = this.initvalue.accountclass;
    this.edit_options = Object.assign({}, this.initvalue.options);
    if(!this.initvalue._id) this.$router.push({ name: 'AccountList' });
    if(this.accounts.length==0) await this.getAccountsRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
